import { defineStore } from 'pinia'
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";

export const useProjectSettingsStore = defineStore({
    id: 'projectSettings',
    state: () => {
        return {
            rooms: [],
            furnitures: [],
        }
    },
    actions: {
        async fetchRooms(type) {
            axios.get(ApiHelper.getAllRoomsUrl(type), {
                headers: authHelper.authHeader(),
            }).then(result => {
                this.rooms = result.data
            }).catch(errorResponse => {
            });
        },
        async fetchFurnitures() {
            axios.get(ApiHelper.getAllFurnituresUrl(), {
                headers: authHelper.authHeader(),
            }).then(result => {
                this.furnitures = result.data
            }).catch(errorResponse => {
            });
        },
    },
});
